<div class="home-carousel-wrap">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-auto">
                <h2>Skills:</h2>
                <!-- <h2>Skill<span class="span1" [ngClass]="{'activeS': skillsHover}">s</span><span class="span2" [ngClass]="{'activeCo': skillsHover}">:</span></h2> -->
            </div>
        </div>
        <div id="skill-carousel" class="carousel slide" data-ride="carousel" data-interval="false">
            <div class="carousel-inner">

                <div class="carousel-item" [ngClass]="{'active': !removeHtml}">
                    <div class="row html-wrap justify-content-center align-items-center">
                        <div class="intro-animation-wrap">
                            <div class="name-wrap barlow" [ngClass]="{'highlight': highlightHtml}" #htmlAnimation>
                                <div *ngFor="let letter of textArr" [ngClass]="{'d-block': (letter == '*'), 'space': (letter == ' '), 'tab': (letter == '_')}">{{letter}}</div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="carousel-item" [ngClass]="{'active': removeHtml}">
                    <div class="row css-wrap justify-content-center">
                        <div>
                            <h1>Nice!</h1>
                        </div>
                    </div>
                </div>
                <!-- <div class="carousel-item">
                <img class="d-block w-100" src="..." alt="Second slide">
                </div>
                <div class="carousel-item">
                <img class="d-block w-100" src="..." alt="Third slide">
                </div> -->
            </div>
        </div>
    </div>
</div>

